export default __webpack_public_path__ + "static/media/arrow-up-right-white.ba9d7ffc.svg";